import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from "lodash.isempty";
import moment from 'moment';

import { messages as jobmessages, debtorStatusMessages, debtorStatusDescs, mainStatusText } from '../views/Job/Job.messages';
import { JOB_ENERGYTYPE } from '../constants';

const InvoiceStatusInfo = (props) => {
    const lng = props.intl.formatMessage;
    const dateNow = moment(new Date()).format('YYYY-MM-DD');
    const debtorStatusText = typeof debtorStatusMessages['statuscode' + props.job.debtor_statuscode] !== "undefined" && debtorStatusMessages['statuscode' + props.job.debtor_statuscode] !== "" ? lng(debtorStatusMessages['statuscode' + props.job.debtor_statuscode]) : '';
    let debtorStatusDesc = null;

    // sets status descriptions, if any are related to the job
    if (typeof debtorStatusDescs['statusdesc' + props.job.debtor_statuscode] !== "undefined" && debtorStatusDescs['statusdesc' + props.job.debtor_statuscode] !== "") {

        // Check if job status is cut off warning and energytype is other than electricity or by default empty
        const nonElectricityCutOffWarning = (props.job.statuscode === 156 && !isEmpty(props.job.energytype) && props.job.energytype !== JOB_ENERGYTYPE.ELECTRICITY);

        // As long as job is other than non electricity cutoff warning, display the status description
        if (!nonElectricityCutOffWarning) {
            debtorStatusDesc = lng(debtorStatusDescs['statusdesc' + props.job.debtor_statuscode]);
        }
    }

    const resolveInvoiceStatusText = () => {
        if (props.job.statuscode === 104) {
            return lng(debtorStatusMessages.statuscode104);
        }
        // Set invoice status based on job status
        switch (props.job.job_main_statuscode) {
            case 0:
                // If duedate is due show status 'late'
                if (props.job.paydate !== undefined && props.job.paydate < dateNow) {
                    return lng(mainStatusText.late);
                } else {
                    return lng(mainStatusText.invoice);
                }
            case 1:
                return lng(mainStatusText.reminder);
            case 2:
                return lng(mainStatusText.collection);
            case 101:
                return lng(mainStatusText.paid);
            case 122:
                return lng(mainStatusText.processing);
            default:
                return '';
        }
    }

    return (
        <>
            <span className='label'>{lng(jobmessages.statusLabel)}</span>
            <span className='float-end text-end'> {resolveInvoiceStatusText()} </span>
            {/* Show debtor status text only if it's not the same as invoice main status text */}
            {resolveInvoiceStatusText() !== debtorStatusText && (
                <p className='mt-3'>
                    {debtorStatusText}
                </p>
            )}

            {/* Show additional status description, if available */}
            {debtorStatusDesc !== null && (
                <div id='job-statusdesc-warning'>
                    <p >{debtorStatusDesc}</p>
                </div>
            )}
        </>
    );
};

InvoiceStatusInfo.propTypes = {
    'intl': PropTypes.object.isRequired,
    'job': PropTypes.object
};

export default InvoiceStatusInfo;